import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const TemplateDeploymentStacksEmpty = () => {
  return (
    <EmptyState
      icon={EmptystateSearchNoResultsColored}
      title="No stacks"
      caption="This deployment has no stacks."
      announce
    />
  );
};

export default TemplateDeploymentStacksEmpty;
